export const payFrequency = {
  MONTHLY: 'MENSUAL',
  BIMONTHLY: 'BIMESTRAL',
  QUARTERLY: 'TRIMESTRAL',
  BIANNUAL: 'SEMESTRAL',
};

export const payFrequencyNumberDays = {
  MONTHLY: 30,
  BIMONTHLY: 60,
  QUARTERLY: 90,
  BIANNUAL: 180,
};

export const numberOfPeriods = {
  BIANNUAL: 2,
  BIMONTHLY: 6,
  MONTHLY: 12,
  QUARTERLY: 4,
};
